import {markAutologinPending, useAutoLogin} from "@mytour/platform";
import {Loading} from "@mytour/ui/Loading";
import type {ReactNode} from "react";
import {useEffect} from "react";
import {Navigate, useLocation, useNavigate, useParams} from "react-router";
import {Button} from "reactstrap";

const FACK_TEST_INVITATION_KEY_PREFIX = "fack-test-";

function CenteredStatusMessage({children}: {children: ReactNode}) {
  return (
    <div
      style={{
        height: "100%",
        display: "grid",
        gridTemplateRows: "1fr min-content 1fr",
      }}
    >
      <div />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {children}
      </div>
      <div />
    </div>
  );
}

export function AutoLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const {invitationKey} = useParams<{invitationKey: string}>();
  const isFackTest = invitationKey?.startsWith(FACK_TEST_INVITATION_KEY_PREFIX) ?? false;

  const {
    autoLogin: onboarding,
    autoLoginError: onboardingError,
    onboardingCompleted: onboardingSuccess,
  } = useAutoLogin();

  useEffect(() => {
    if (invitationKey && !isFackTest) {
      onboarding({invitationKey});
    }
  }, [invitationKey, isFackTest, onboarding]);

  // Hand the autologin success over to the analytics session watcher, which
  // emits `onboarding_started` once the session queries answer — without
  // delaying the navigation below.
  useEffect(() => {
    if (onboardingSuccess) {
      markAutologinPending();
    }
  }, [onboardingSuccess]);
  if (isFackTest) {
    return (
      <CenteredStatusMessage>
        <h2>{"Redirection test réussie"}</h2>
        <p>{"Aucun compte n'a été créé."}</p>
      </CenteredStatusMessage>
    );
  }
  if (onboardingSuccess) {
    const {from} = (location.state as any) || {from: {pathname: "/", search: location.search}};
    return <Navigate to={from} replace />;
  }
  if (onboardingError) {
    return (
      <CenteredStatusMessage>
        <h2>{"Erreur pendant la connexion automatique"}</h2>
        <p>{`Merci d'utiliser vos identifiants de connexion`}</p>
        <div>
          <Button color="success" onClick={handleRedirectLogin}>
            Se connecter
          </Button>
        </div>
      </CenteredStatusMessage>
    );
  }
  return (
    <>
      <Loading />
    </>
  );

  function handleRedirectLogin() {
    navigate("/login");
  }
}
